import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ThankYou = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!location.state?.paymentSuccess) {
      navigate("/"); 
    }
  }, [location, navigate]);

  return (
    <div className="thankyou">
      <h1>🎉 Thank You!</h1>
      <p>Your visa’s in motion! 🚀 Invoice’s in your inbox 📧 <br></br>Track progress anytime on your dashboard 📊✨</p>
      <a className="dashboard-link" href="/dashboard">Track on Dashboard</a>
    </div>
  );
};

export default ThankYou;